/* TANKS theme scripts */
(function () {
  // Header toggles (mobile menu + search)
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle]');
    if (!t) return;
    var target = document.getElementById(t.getAttribute('data-toggle'));
    if (!target) return;
    var open = target.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var input = target.querySelector('input[type="search"]');
      if (input) input.focus();
    }
  });

  // Quantity buttons
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v = b.getAttribute('data-qty') === 'plus' ? v + 1 : Math.max(parseInt(input.min || '1', 10), v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Product gallery thumbnails
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    showMedia(gallery, thumb.getAttribute('data-thumb'));
  });

  function showMedia(gallery, mediaId) {
    if (!gallery || !mediaId) return;
    var main = gallery.querySelector('[data-main-image] img');
    var thumb = gallery.querySelector('[data-thumb="' + mediaId + '"]');
    if (!main || !thumb) return;
    main.src = thumb.getAttribute('data-src');
    main.removeAttribute('srcset');
    main.alt = thumb.getAttribute('data-alt') || '';
    gallery.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.setAttribute('aria-current', b === thumb ? 'true' : 'false');
    });
  }

  // Variant selection
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var jsonEl = form.querySelector('[data-variants]');
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var section = form.closest('[data-product-section]');
    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('[data-add-button]');
    var priceEl = section.querySelector('[data-price]');
    var money = function (cents) {
      var fmt = form.getAttribute('data-money-format') || '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount\s*\}\}/, amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
                .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
    };

    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option]')) return;
      var selected = Array.prototype.map.call(
        form.querySelectorAll('fieldset[data-option-index]'),
        function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; }
      );
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-unavailable');
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? addBtn.getAttribute('data-add') : addBtn.getAttribute('data-soldout');
      if (priceEl) {
        priceEl.innerHTML = (variant.compare_at_price > variant.price ? '<s>' + money(variant.compare_at_price) + '</s>' : '') +
          '<span class="price__current">' + money(variant.price) + '</span>';
      }
      if (variant.featured_media) showMedia(section.querySelector('[data-gallery]'), String(variant.featured_media.id));
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    });
  });
})();
